import {usePath} from '../../../hooks';
import {useModalControls} from '@chekin/guestapp-ui-kit';
import {useFetchIVLottie} from '@chekin/shared';
import {PATHS} from 'routes/constants';
import {AutoFillBox} from './AutoFillBox';
import {AutoFillModalContent} from './AutoFillModalContent';

export function AutoFill() {
  const {
    isOpen: isOpenConfirmAutoFillModal,
    openModal: openConfirmAutoFillModal,
    closeModal: closeConfirmAutoFillModal,
  } = useModalControls();
  const {getFullPath} = usePath();
  const {animationData: ocrAnimationLottie} = useFetchIVLottie({isOCR: true});

  return (
    <>
      <AutoFillBox onClick={openConfirmAutoFillModal} className="auto-fill-card" />
      <AutoFillModalContent
        open={isOpenConfirmAutoFillModal}
        onClose={closeConfirmAutoFillModal}
        lottie={ocrAnimationLottie}
        scanPath={getFullPath(PATHS.documentMRZ)}
      />
    </>
  );
}
